// extracted by mini-css-extract-plugin
export default {"schalude-mailing-item":"style_schalude-mailing-item__4xGtr","mailing-title":"style_mailing-title__q9ztj"};